export default ['$scope', '$routeParams', 'users', 'wbConfig', 'locale', 'toggle', 'AccountBalances', function($scope, $routeParams, users, wbConfig, locale, toggle, AccountBalances) {
  this.config = wbConfig;

  toggle.register($scope);

  this.investmentsAtCidi;
  this.savingsAtCidi;
  this.investmentsTotal;
  this.netWorth;
  this.userId;
  this.prevIncludeHouseholdAssetsAndDebts;
  this.prevInvestmentsOther;
  this.prevAssetsLiquid;
  this.prevAssetsFixed;
  this.prevDebtTotal;

  if (users.getCurrentUser().roles.includes('staff')) {
    this.userId = $routeParams.userId;
  } else {
    this.userId = users.getCurrentUser().id;
  }

  this.getAccountBalances = () => {
    return AccountBalances.get({id: this.userId}, accountBalances => {
      this.investmentsAtCidi = parseFloat(accountBalances.investmentsBalance);
      this.savingsAtCidi = parseFloat(accountBalances.savingsBalance);
      if (this.clientProfile.includeHouseholdAssetsAndDebts) {
        this.investmentsAtCidi = parseFloat(accountBalances.investmentsJointBalance);
        this.savingsAtCidi = parseFloat(accountBalances.savingsJointBalance);
      }
    }).$promise;
  }

  this.calculateTotalAssets = () => {
    if (!this.clientProfile) return null;
    this.investmentsTotal = this.investmentsAtCidi + this.savingsAtCidi + this.clientProfile.investmentsOther + this.clientProfile.assetsLiquid + this.clientProfile.assetsFixed;
  }

  this.calculateNetWorth = () => {
    if (!this.clientProfile) return null;
    this.netWorth = this.investmentsTotal - this.clientProfile.debtTotal;
  }

  $scope.$watch('ctrl.clientProfile', async clientProfile => {
    if (clientProfile == null) { return; }
    await this.getAccountBalances();
    this.calculateTotalAssets();
    this.calculateNetWorth();
    this.prevIncludeHouseholdAssetsAndDebts = clientProfile.includeHouseholdAssetsAndDebts;
    this.prevInvestmentsOther = clientProfile.investmentsOther;
    this.prevAssetsLiquid = clientProfile.assetsLiquid;
    this.prevAssetsFixed = clientProfile.assetsFixed;
    this.prevDebtTotal = clientProfile.debtTotal;
  });

  $scope.$watch('ctrl.clientProfile.includeHouseholdAssetsAndDebts', async includeHouseholdAssetsAndDebts => {
    if (!this.clientProfile) { return; }
    if (includeHouseholdAssetsAndDebts == this.prevIncludeHouseholdAssetsAndDebts) { return; }
    await this.getAccountBalances();
    this.calculateTotalAssets();
    this.calculateNetWorth();
    this.prevIncludeHouseholdAssetsAndDebts = includeHouseholdAssetsAndDebts;
  });

  $scope.$watch('ctrl.clientProfile.investmentsOther', investmentsOther => {
    if (!this.clientProfile) { return; }
    if (investmentsOther == this.prevInvestmentsOther) { return; }
    this.calculateTotalAssets();
    this.calculateNetWorth();
    this.prevInvestmentsOther = investmentsOther;
  });

  $scope.$watch('ctrl.clientProfile.assetsLiquid', assetsLiquid => {
    if (!this.clientProfile) { return; }
    if (assetsLiquid == this.prevAssetsLiquid) { return; }
    this.calculateTotalAssets();
    this.calculateNetWorth();
    this.prevAssetsLiquid = assetsLiquid;
  });

  $scope.$watch('ctrl.clientProfile.assetsFixed', assetsFixed => {
    if (!this.clientProfile) { return; }
    if (assetsFixed == this.prevAssetsFixed) { return; }
    this.calculateTotalAssets();
    this.calculateNetWorth();
    this.prevAssetsFixed = assetsFixed;
  });

  $scope.$watch('ctrl.clientProfile.debtTotal', debtTotal => {
    if (!this.clientProfile) { return; }
    if (debtTotal == this.prevDebtTotal) { return; }
    this.calculateTotalAssets();
    this.calculateNetWorth();
    this.prevDebtTotal = debtTotal;
  });

  return this;
}];